import { Helmet } from 'react-helmet-async';

const SEO = ({ language }) => {
  const isSpanish = language === 'es';

  const seoData = {
    en: {
      title: 'Professional Cleaning Services Connecticut | Brilliant Touch | 5-Star Rated',
      description: 'Top professional cleaning services in CT. Residential & commercial cleaning Waterbury, Hartford, New Haven. Same-day service, eco-friendly, 100% satisfaction guarantee. 500+ 5-star reviews. Call (475) 343-7298 for FREE quote!',
      keywords: 'cleaning services Connecticut, professional cleaning CT, house cleaning Waterbury, residential cleaning Hartford, commercial cleaning New Haven, office cleaning Connecticut, apartment cleaning CT, deep cleaning services, move in move out cleaning, post construction cleaning, eco-friendly cleaning Connecticut, maid service CT, home cleaning near me, cleaning company Waterbury, professional cleaners Hartford, janitorial services Connecticut, recurring cleaning service, weekly cleaning CT, biweekly cleaning service, monthly cleaning Connecticut, best cleaning service near me, affordable house cleaning, cleaning lady Connecticut, housekeeping services CT, cleaning business Waterbury',
      ogTitle: 'Brilliant Touch - Connecticut\'s #1 Professional Cleaning Service | 500+ 5-Star Reviews',
      ogDescription: '🌟 Award-winning cleaning services across CT. Residential, commercial & post-construction. Eco-friendly products. Same-day available. 100% satisfaction guarantee. Book today & get 10% off!',
    },
    es: {
      title: 'Servicios de Limpieza Profesional Connecticut | Brilliant Touch | 5 Estrellas',
      description: 'Servicios de limpieza profesional #1 en CT. Limpieza residencial y comercial Waterbury, Hartford, New Haven. Servicio mismo día, eco-amigable, 100% garantía. 500+ reseñas 5 estrellas. ¡Llama (475) 343-7298 cotización GRATIS!',
      keywords: 'servicios de limpieza Connecticut, limpieza profesional CT, limpieza de casas Waterbury, limpieza residencial Hartford, limpieza comercial New Haven, limpieza de oficinas Connecticut, limpieza de apartamentos CT, servicio de limpieza profunda, limpieza mudanza, limpieza post construcción, limpieza ecológica Connecticut, servicio de mucama CT, limpieza de hogar cerca de mi, compañía de limpieza Waterbury, limpiadores profesionales Hartford, servicios de conserjería Connecticut, servicio de limpieza recurrente, limpieza semanal CT, servicio de limpieza quincenal, limpieza mensual Connecticut',
      ogTitle: 'Brilliant Touch - Servicio de Limpieza Profesional #1 en Connecticut | 500+ Reseñas 5 Estrellas',
      ogDescription: '🌟 Servicios de limpieza galardonados en CT. Residencial, comercial y post-construcción. Productos eco-amigables. Mismo día disponible. 100% garantía. ¡Reserva hoy y obtén 10% descuento!',
    }
  };

  const data = isSpanish ? seoData.es : seoData.en;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Brilliant Touch Professional Cleaning",
    "image": "https://site-draft-7.preview.emergentagent.com/assets/logo-main.png",
    "@id": "https://share.google/4twB5KhV2uvApcjAQ",
    "url": "https://site-draft-7.preview.emergentagent.com",
    "telephone": "+14753437298",
    "email": "groupbrillianttouch@gmail.com",
    "priceRange": "$$",
    "paymentAccepted": "Cash, Credit Card, Zelle, Venmo",
    "currenciesAccepted": "USD",
    "openingHours": "Mo-Su 07:00-20:00",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "",
      "addressLocality": "Waterbury",
      "addressRegion": "CT",
      "postalCode": "",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 41.5582,
      "longitude": -73.0515
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "07:00",
      "closes": "20:00"
    },
    "sameAs": [
      "https://www.facebook.com/share/1bnLQzovdo/?mibextid=wwXIfr",
      "https://www.instagram.com/brillianttouch_ct?igsh=ZWFhZzBsa3l4bXpo&utm_source=qr",
      "https://www.tiktok.com/@brilliant.touch6?_r=1&_t=ZT-96dq1lmvqm5",
      "https://share.google/4twB5KhV2uvApcjAQ"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "500"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cleaning Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Residential Cleaning",
            "description": "Professional home and condo cleaning services including deep cleaning, regular maintenance, and move-in/out cleaning",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Brilliant Touch Professional Cleaning"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Commercial Cleaning",
            "description": "Office, retail, and commercial space cleaning with flexible scheduling",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Brilliant Touch Professional Cleaning"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Post-Construction Cleaning",
            "description": "Final cleanup for construction and renovation projects",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Brilliant Touch Professional Cleaning"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Move-In/Move-Out Cleaning",
            "description": "Deep cleaning for property turnovers and relocations",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Brilliant Touch Professional Cleaning"
            }
          }
        }
      ]
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": isSpanish ? "¿Qué áreas de Connecticut cubren?" : "What areas of Connecticut do you serve?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": isSpanish 
            ? "Servimos Waterbury, Hartford, New Haven, Meriden, Bridgeport, Danbury y áreas circundantes en Connecticut. Ofrecemos servicio flexible de lunes a domingo de 7am a 8pm."
            : "We serve Waterbury, Hartford, New Haven, Meriden, Bridgeport, Danbury, and surrounding areas in Connecticut. We offer flexible service Monday through Sunday from 7am to 8pm."
        }
      },
      {
        "@type": "Question",
        "name": isSpanish ? "¿Cuánto cuesta el servicio de limpieza?" : "How much does cleaning service cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": isSpanish
            ? "Nuestros precios varían según el tamaño de la propiedad y el tipo de limpieza. Ofrecemos cotizaciones gratuitas personalizadas. Llama al (475) 343-7298 para obtener tu cotización gratuita hoy."
            : "Our pricing varies based on property size and cleaning type. We offer free customized quotes. Call (475) 343-7298 to get your free quote today."
        }
      },
      {
        "@type": "Question",
        "name": isSpanish ? "¿Están asegurados y tienen licencia?" : "Are you insured and licensed?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": isSpanish
            ? "Sí, Brilliant Touch está completamente asegurado y licenciado. Todos nuestros limpiadores profesionales están capacitados, verificados y asegurados para tu tranquilidad."
            : "Yes, Brilliant Touch is fully insured and licensed. All our professional cleaners are trained, background-checked, and insured for your peace of mind."
        }
      },
      {
        "@type": "Question",
        "name": isSpanish ? "¿Ofrecen servicio el mismo día?" : "Do you offer same-day service?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": isSpanish
            ? "Sí, ofrecemos servicio de emergencia 24/7 según disponibilidad. Contáctanos lo antes posible para verificar la disponibilidad para tu área."
            : "Yes, we offer 24/7 emergency service based on availability. Contact us as soon as possible to check availability for your area."
        }
      },
      {
        "@type": "Question",
        "name": isSpanish ? "¿Usan productos eco-amigables?" : "Do you use eco-friendly products?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": isSpanish
            ? "Sí, usamos productos de limpieza eco-amigables que son seguros para niños, mascotas y el medio ambiente. También ofrecemos opciones de limpieza verde bajo pedido."
            : "Yes, we use eco-friendly cleaning products that are safe for children, pets, and the environment. We also offer green cleaning options upon request."
        }
      }
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={isSpanish ? 'es' : 'en'} />
      <title>{data.title}</title>
      <meta name="title" content={data.title} />
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      
      {/* Robots */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://site-draft-7.preview.emergentagent.com/" />
      <meta property="og:title" content={data.ogTitle} />
      <meta property="og:description" content={data.ogDescription} />
      <meta property="og:image" content="https://site-draft-7.preview.emergentagent.com/assets/logo-main.png" />
      <meta property="og:locale" content={isSpanish ? 'es_ES' : 'en_US'} />
      <meta property="og:site_name" content="Brilliant Touch Professional Cleaning" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://site-draft-7.preview.emergentagent.com/" />
      <meta property="twitter:title" content={data.ogTitle} />
      <meta property="twitter:description" content={data.ogDescription} />
      <meta property="twitter:image" content="https://site-draft-7.preview.emergentagent.com/assets/logo-main.png" />
      
      {/* Additional SEO */}
      <meta name="author" content="Brilliant Touch Professional Cleaning" />
      <meta name="geo.region" content="US-CT" />
      <meta name="geo.placename" content="Connecticut" />
      <meta name="geo.position" content="41.5582;-73.0515" />
      <meta name="ICBM" content="41.5582, -73.0515" />
      
      {/* Canonical */}
      <link rel="canonical" href="https://site-draft-7.preview.emergentagent.com/" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* FAQ Schema */}
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
